import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    url: "/api/search/get",
    method: "post",
    data,
  });
}
